import { SelectionModel } from "@angular/cdk/collections";
import { Component, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatStepper, MatStepperModule } from "@angular/material/stepper";
import { MatTableDataSource } from "@angular/material/table";
import { PaginationInstance } from "ngx-pagination";
import { AssignCourseComponent } from "src/app/pages/courses/assign-course/assign-course.component";
import { GlobalService } from "src/app/services/global/global.service";
import { MatDialog } from '@angular/material/dialog';
import { Filter } from "src/app/pages/filter/filter.model";
import { AppService } from "src/app/services/app/app.service";
import { UserManagementService } from "src/app/services/user_management/user-management.service";
import { MatSort, Sort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { CommonService } from "src/app/services/common/common.service";
import { NgxSpinnerService } from "ngx-spinner";
import { LiveAnnouncer } from "@angular/cdk/a11y";
import { TimeClockService } from "src/app/services/time-clock/time-clock.service";

@Component({
  selector: 'app-add-clock-card',
  templateUrl: './add-clock-card.component.html',
  styleUrls: ['./add-clock-card.component.scss']
})
export class AddClockCardComponent {
  selectedElements: any[] = [];
  isFirstStepClicked: boolean = false;
  @ViewChild("stepper") stepper!: MatStepper;
  requiresAdminApproval = true;
  timeOffLimitations = false;
  timeOffLimitDays = 7;
  timeOffUnit = "days";
  public dataSourceEmp = new MatTableDataSource();
  displayedColumns: string[] = ["select", "demo-name",];
  public displayedColumnsEmp: string[] = ['select', 'first_name', 'department', 'phone_number'];
  selection = new SelectionModel<any>(true, []);
  public maxPaginationSize = GlobalService.maxPaginationSize
  public searchInput: string = "";
  private previousInputValue: string = "";
  pageSize = 15;
  public countEmp!: any;
  public pageSizeOptions = GlobalService.pageSizeOptions;
  @ViewChild('sortEmp') sortEmp!: MatSort;
  @ViewChild(MatPaginator) paginatorEmp!: MatPaginator;
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public filterObj: Filter = {
    operand: "or",
    arr: []
  };
  public filterArr: any[] = [
    { key_name: "First Name", key_val: "first_name", type: 'text' },
    { key_name: "Last Name", key_val: "last_name", type: 'text' },
    { key_name: "Email", key_val: "email", type: 'text' },
  ]
  public isFilterShow: boolean = false;
  public isSelectAll: boolean = false;
  public imageURL: any = GlobalService.imageURL;
  public assignedEmp: any[] = [];

  constructor(public dialogRef: MatDialogRef<AssignCourseComponent>, private dialog: MatDialog, private spinner: NgxSpinnerService,
    private appService: AppService, private userManagementService: UserManagementService, private commonService: CommonService,
    private _liveAnnouncer: LiveAnnouncer, private timeClockService: TimeClockService, @Inject(MAT_DIALOG_DATA) public dialogData: any,) { }

  ngOnInit(): void {
    this.onPageChange(1);
    if (this.dialogData && this.dialogData.id) {
      this.getAssignedList();
    }
  }

  onFirstNextClick() {
    // this.isFirstStepClicked = true;
    this.stepper.next();
  }
 
  toggleDaySelection(day) {
    day.selected = !day.selected;
  }
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == "" && this.previousInputValue !== "") {
      this.config.currentPage = 0;
      this.empList(this.pageSize, 0);
      // this.noticesList();
    }
  }
  onGo() {
    if (this.searchInput.trim() != "") {
      this.config.currentPage = 0;
      this.empList(this.pageSize, 0);
      //   this.noticesList();
    }
  }
  onFilterView() {
    this.isFilterShow = !this.isFilterShow;
  }
  callApi(obj) {
    this.filterObj = obj;
    this.empList(this.pageSize, 0);
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement;
    this.config.itemsPerPage = Number(tar.value);
    this.config.currentPage = 1;
    this.empList(this.pageSize, 0);
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.empList(this.pageSize, 0);
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceEmp.data.length;
    return numSelected === numRows;
  }
  masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.dataSourceEmp.data.forEach((row) => this.selection.select(row));
  }
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.name}`;
  }
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  capitalizeFirstLetter(text: string) {
    if (text != '' || text != null) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
    else {
      return text;
    }
  }
  onSelectAll(event) {
    if (event.checked) {
      this.dataSourceEmp.data.forEach((item: any) => {
        item.selected = true;
        if (!this.selectedElements.includes(item)) {
          this.selectedElements.push(item);
        }
      });
      this.isSelectAll = true;
    } else {
      this.dataSourceEmp.data.forEach((item: any) => {
        item.selected = false;
        this.selectedElements = this.selectedElements.filter((selectedItem) => selectedItem !== item);
      });
      this.isSelectAll = false;
    }
  }
  onSelectSingle(event, element) {
    if (event.checked) {
      element.selected = true;
      this.selectedElements.push(element);
    } else {
      element.selected = false;
      this.selectedElements = this.selectedElements.filter((selectedItem) => selectedItem !== element);
    }
    const selectedCount = this.dataSourceEmp.data.filter((item: any) => item.selected).length;
    // this.isSelectAll = selectedCount === this.dataSourceEmp.data.length;
  }
  onClose() {
    this.dialogRef.close();
  }
  empList = (pageSize: number, size: number): void => {
    this.dataSourceEmp.data = [];
    this.spinner.show();
    let obj;
    obj = {
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      f_a: this.filterObj.arr,
      op_nd: this.filterObj.operand,
      sh: this.searchInput.trim(),
      pl_id: "",
    }
    this.userManagementService.empList(obj).subscribe({
      next: (success: any) => {


        this.previousInputValue = this.searchInput;
        this.spinner.hide();
        success.data.employee_list.map((item: any) => item.first_name = this.capitalizeFirstLetter(item.first_name))
        this.dataSourceEmp = new MatTableDataSource(success.data.employee_list);
        this.dataSourceEmp.data.map((item: any) => { item["selected"] = "" });

        this.countEmp = success.count;
        this.dataSourceEmp.sort = this.sortEmp;
        this.dataSourceEmp.paginator = this.paginatorEmp;
        if (this.selectedElements.length > 0) {
          this.dataSourceEmp.data.map((dataItem: any) => {
            if(this.assignedEmp.length > 0 && this.assignedEmp.includes(dataItem.employee_id)){
              this.selectedElements.push(dataItem)
            }
            const matchedSelected = this.selectedElements.find((selectedItem) => selectedItem.employee_id === dataItem.employee_id);
            dataItem.selected = !!matchedSelected;
            return dataItem;
            
          });
        }
        if (this.isSelectAll == true) {
          this.dataSourceEmp.data.map((item: any) => { item["selected"] = true })
        }
        // Assuming you have two arrays named `array1` and `array2`
      },
      error: (error: any) => {
        this.spinner.hide();
        this.previousInputValue = this.searchInput;
        this.commonService.handleError(error);
      }
    }
    );
  }
  getAssignedList() {
    let obj = {
      "tc_id": this.dialogData.id,
    }
    this.timeClockService.getAssignClock(obj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          // let empArr: any[] = [];
          // empArr = success.msg["emp"];
          setTimeout(() =>{
            this.assignedEmp = []
          this.assignedEmp = success.msg["emp"];
          this.selectedElements = [];

          //if already selected employee then add it as selected.
          this.dataSourceEmp.data.map((dataItem: any) => {
            if (this.assignedEmp.includes(dataItem.employee_id)) {
              dataItem.selected = true;
              this.selectedElements.push(dataItem)
            }
            else {
              dataItem.selected = false;
            }
            return dataItem;
          });
          },100)
        }
      },
      error: (error: any) => {
        //   this.isSpinnerLoading = false
        this.commonService.handleError(error);
      }
    })
  }
  onSubmitAssign() {
    let empId: any[] = [];
    for (let i = 0; i < this.selectedElements.length; i++) {
      if (this.selectedElements[i]['selected'] == true) {
        empId.push(this.selectedElements[i]['employee_id']);
      }
    }
    let obj: {} = {
      "emp": empId,
      "tc_id": this.dialogData.id
    }
    if (this.isSelectAll) {
      obj["emp"] = "selectall";
    }
    if(this.assignedEmp.length==0){
      this.onSubmitAssignCard(obj);
    }
    else{
    this.onSubmitAssignCard(obj);
    }
  }
  onSubmitAssignCard(obj) {
    this.spinner.show();
    this.timeClockService.assignClockCard(obj).subscribe({
      next: (data: any) => {
        this.spinner.hide();
        if (data["status"] == 200) {
          this.appService.showToastMessage('success', data["msg"]);
          this.dialogRef.close();
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      }
    })
  }
  onSubmitAssignCardEdit(obj) {
    this.spinner.show();
    this.timeClockService.editAssignClockCard(obj).subscribe({
      next: (data: any) => {
        this.spinner.hide();
        if (data["status"] == 200) {
          this.appService.showToastMessage('success', data["msg"]);
          this.dialogRef.close();
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      }
    })
  }
}

